module.exports = "images/get-inspired-6.jpg";